import leaflet from "leaflet"; 
import { useEffect, useRef, useState } from "react";
import {  useHistory } from "react-router-dom";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaTokenExt} from "../funciones/ClienteAxios";
import axios from 'axios';
import moment from 'moment';
export default function MapaLeaflet({lista, listaPromovid, listLider, listRecorrido, verEtiq}) {
  const mapRef = useRef()
  //const params = useParams()
  let history = useHistory();
  const source = axios.CancelToken.source();
  const [cargando, setCargando] = useState(true)
  const [centro, setCentro] = useState([-17.3936218,-66.2336069])
  const [listPoligono, setListPoligono] = useState([])
  const hoy=moment(new Date()).format('YYYY-MM-DD')      

  useEffect(()=>{         
    
   // getListPoligono(1, "1", 9, municipioId)
    //getListMarcador(1, "1", 9, municipioId)
    
   mapRef.current =  leaflet.map('map').setView([19.3172475,-98.9922521], 13);
    leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(mapRef.current);  

    //const greenIcon = nvoIconLeaflet('/marker-icon-2x-green.png') 
    mapRef.current.setView([lista[0].Lat, lista[0].Lon]);
    let arrPoligono=[]
    lista.forEach((poligono)=>{
      let arrPath=[]
      if (poligono.gps) {
        poligono.gps.forEach((paths)=>{
          arrPath.push([paths.Lat,paths.Lon])
        })
      }
      arrPoligono.push(arrPath)
      //let marker = leaflet.marker([poligono.Lat,poligono.Lon],{icon:greenIcon});    
      //const cadena=`${poligono.Num}`          
      //marker.bindPopup(cadena).openPopup();
    //  marker.addTo(mapRef.current).on('click', mostrar);
    })   
    const polygon = leaflet.polygon(arrPoligono, { fillOpacity: 0.5, fillColor: '#9a8fcd' });
    polygon.addTo(mapRef.current); 

    return () => {
      mapRef.current = null
      source.cancel();
    }

  },[]) 

  useEffect(()=>{         
    
    if (listaPromovid && listaPromovid.lenght!== 0 ) {
      listaPromovid.forEach((poligono)=>{
        if (poligono.Id!== -1 && poligono.Id!== "-1" ) 
        { let arrPath=[]
          if (poligono.gps) {
            poligono.gps.forEach((paths)=>{
              arrPath.push([paths.Lat,paths.Lon])
            })
          }      
          const promoIcon = nvoIconLeaflet('/marker-icon-2x-green.png')

          let marker = leaflet.marker([poligono.Lat,poligono.Lon],{icon:promoIcon});    
          const cadena=`${poligono.Nom}`          
          marker.bindPopup(cadena).openPopup();
          marker.addTo(mapRef.current).on('click', mostrar);  
        }
        
      })         
    }          
    
    if (listLider && listLider.lenght!== 0) {
      listLider.forEach((poligono)=>{
        if (poligono.Id!== -1 && poligono.Id!== "-1" ) 
        { let arrPath=[]
          if (poligono.gps) {
            poligono.gps.forEach((paths)=>{
              arrPath.push([paths.Lat,paths.Lon])
            })
          }      
          const liderIcon = nvoIconLeaflet('/marcador-militante.svg')
          let marker = leaflet.marker([poligono.Lat,poligono.Lon],{icon:liderIcon});    
          const cadena=`${poligono.Obsrv}`          
          marker.bindPopup(cadena).openPopup();
          marker.addTo(mapRef.current).on('click', mostrar);
        }
      })         
    }    

    if (listRecorrido && listRecorrido.lenght!== 0) {
      listRecorrido.forEach((poligono)=>{
        if (poligono.Id!== -1 && poligono.Id!== "-1" ) 
        {
          let arrPath=[]
          if (poligono.gps) {
            poligono.gps.forEach((paths)=>{
              arrPath.push([paths.Lat,paths.Lon])
            })
          }      
          const recorridoIcon =nvoIconLeaflet('/marca_recorrido.svg') 
          let marker = leaflet.marker([poligono.Lat,poligono.Lon],{icon:recorridoIcon});    
          const cadena=`${poligono.Obsrv}`          
          marker.bindPopup(cadena).openPopup();
          marker.addTo(mapRef.current).on('click', mostrar);
        }
      })         
    } 

    if (verEtiq !== null && verEtiq) {
      lista.forEach((poligono)=>{
        let arrPath=[]
        if ( poligono.gps) {
          poligono.gps.forEach((paths)=>{
            arrPath.push([paths.Lat, paths.Lon])
          })
        }      
        const iconUrl = `https://daduva-cartografia.sfo3.cdn.digitaloceanspaces.com/Sec/Secc${poligono.Num}.svg`        
        const icono =nvoIconLeaflet(iconUrl,46)
        let marker = leaflet.marker([poligono.Lat,poligono.Lon],{icon:icono});            
        marker.addTo(mapRef.current)
      })         
    } 
 
  },[listaPromovid, listLider, listRecorrido, verEtiq]) 

  const nvoIconLeaflet=(iconUrl, iconAncho)=>{
    const nvo=new leaflet.Icon({
      iconUrl: iconUrl,
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [iconAncho??25, 41],
      iconAnchor: [iconAncho??12, 41],
      popupAnchor: [1, -34],
      shadowSize: [iconAncho??41, 41]
    });
    return nvo
  }

  function getListPoligono(usuId, auxToken, edoId, munId) {
    const data = qs.stringify({
      usuario: usuId,  
      estado:edoId,
      municipio:munId,
      ip:"127.0.0.0",         
      idDispositivo: "451224452121"
    });

    const url = "https://datacubic.daduva.app/api/lugar/colonia/gps/poligono";

    function respuesta(response) {
      if (response[0].Id !== -1) {
        setListPoligono(response)     
        let arrPoligono=[]
        
      }
    }

    llamaApiCargaTokenExt(data, url, respuesta, ErrorGeneral, setCargando, history,source,auxToken, );
  }
  
  function getListMarcador(usuId, auxToken, edoId, munId) {    
    const data = qs.stringify({
      Usuario: usuId,        
      Fini:"2025-01-01T00:00:00",
      Ffin:`${hoy}T23:59:59`,
      Status:0,
      Tipo:0,
      Estado:edoId,
      Municipio:munId,
      Seccion:0,
      ip:"127.0.0.0",
      idDispositivo: "451224452121"
    });

    const url = "https://datacubic.daduva.app/api/producto/gps/v1/avance";

    function respuesta(response) {
      if (response[0].Id !== -1) {
        setListPoligono(response)     
        let redIcon = nvoIconLeaflet("/marker-icon-2x-red.png") 
        response.forEach((marcador)=>{
          let marker = leaflet.marker([marcador.Lat,marcador.Lon],{icon:redIcon});    
          const cadena=`<p>${marcador.Nom} ${marcador.Pat} ${marcador.Mat}<br />${marcador.TipoNom}<br/> ${marcador.Tel} ${marcador.Email} <br/> ${marcador.Dir}</p> `
          // Adding popup to the marker
          marker.bindPopup(cadena).openPopup();
          marker.addTo(mapRef.current).on('click', mostrar);
          
        })           
      }
    }

    llamaApiCargaTokenExt(data, url, respuesta, ErrorGeneral, setCargando, history, source, auxToken, );
  }
  

  const mostrar=(e)=>{
    //console.log(e);    
  }
 
  return (  
    <div id="map" ref={mapRef} style={{height:"100%" }}/>  
  );
}